import * as React from 'react';
import { Helmet } from 'react-helmet';

interface FacebookMetaProps {
  appId: string | null;
  pageId: string | null;
}

export const FacebookMeta = ({ appId, pageId }: FacebookMetaProps) => (
  <Helmet>
    {appId ? <meta property="fb:app_id" content={appId} /> : null}
    {pageId ? <meta property="fb:pages" content={pageId} /> : null}
  </Helmet>
);
